import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ServiciodepedidovigenteService {


  constructor() { }

  salidadeservicio;
  querydepedidosactiva;
  querydereportesactiva;
  objetodecamposparareporte={};
  regionalsolicitada;
  coleccionaeditar;
  valoresparaeditar;
  accion;
  proveedorID;
  proveedor;
  origen;
  valoresparaeditartarifa;
  iDdeProveedorRecienCreado;
  valoresDeProveedorRecienCreado = {id:"", nombreproveedor:"", nit: "", emailCuenta: "", emailNotificaciones: "", bloqueado: undefined};
  afeparareporte='';
  ticketdequery='';
  equipodequery='';
  tarifasporequipo=false;
  tarifasporequipoNoHomologado=false
  desdeDondeLlegaAlDashboard="";
  regionalparareporte;
  excelOTabla ="tabla";
  tarifaParaEditarSummary;
  arraydecontratos;
  proveedorparaReporte

  fechaquerymin;
  fechaquerymax;
 


  funciondelservicio(entrada, callback){
    console.log("al servicio llega esto: "+ entrada)
    this.salidadeservicio = entrada;
    callback();
  }

  funciondelistadepedidosseleccionada(query,regional,callback){
    this.querydepedidosactiva = query;
    this.regionalsolicitada =regional;
    callback();
  }

  funciondelistadeReportesseleccionada(query,objetodecamposparareporte,callback){
    this.querydereportesactiva = query;
    this.objetodecamposparareporte=objetodecamposparareporte;
    callback();
  }

  funciondelistadeReportesseleccionadaPorAfe(query,objetodecamposparareporte,afe,callback){
    this.querydereportesactiva = query;
    this.objetodecamposparareporte=objetodecamposparareporte;
    this.afeparareporte = afe;
    callback();
  }

  funciondeMestroDeServiciosPorRegional(query,objetodecamposparareporte,regional,callback){
    this.querydereportesactiva = query;
    this.objetodecamposparareporte=objetodecamposparareporte;
    this.regionalparareporte = regional;
    callback();
  }

  funciondeMestroDeServiciosPorProveedor(query,objetodecamposparareporte,proveedor,callback){
    this.querydereportesactiva = query;
    this.objetodecamposparareporte=objetodecamposparareporte;
    this.proveedorparaReporte = proveedor;
    callback();
  }
  
  funciondeMestroDeServiciosPorConciliados(query,objetodecamposparareporte,proveedor,callback){
    this.querydereportesactiva = query;
    this.objetodecamposparareporte=objetodecamposparareporte;
    this.proveedorparaReporte = proveedor;
    callback();
  }

  funciondeReporteQuimicos(query,objetodecamposparareporte,proveedor,callback){
    this.querydereportesactiva = query;
    this.objetodecamposparareporte=objetodecamposparareporte;
    this.proveedorparaReporte = proveedor;
    callback();
  }

  funciondeReporteRNDC(query,objetodecamposparareporte,proveedor,callback){
    this.querydereportesactiva = query;
    this.objetodecamposparareporte=objetodecamposparareporte;
    this.proveedorparaReporte = proveedor;
    callback();
  }


  

  funciondebusquedapoticket(query,ticket,objetodecamposparareporte,callback){
    this.ticketdequery = ticket
    this.querydereportesactiva = query
    this.objetodecamposparareporte=objetodecamposparareporte;
    callback();
  }

  funciondetarifasporequipo(equipo, callback){
    this.equipodequery=equipo;
    this.tarifasporequipo=true;
    callback();
  }

  funciondetarifasporequipoNoHomologados(equipo, callback){
    this.equipodequery=equipo;
    this.tarifasporequipoNoHomologado=true;
    callback();
  }



  funcionSuperEditor(coleccion, valoresdeentrada, accion,callback){
    this.coleccionaeditar = coleccion;
    this.valoresparaeditar = valoresdeentrada;
    this.accion = accion;
    callback();
  }

  funcionEditorProveedores(proveedorID,valoresdeentrada,accion,callback){
    this.proveedorID = proveedorID;
    this.valoresparaeditar = valoresdeentrada;
    this.accion = accion;
    callback();
  }

  funcionCrearTarifa(proveedor,proveedorID,accion,arraydecontratos,callback){
    this.proveedor = proveedor;
    this.proveedorID = proveedorID;
    this.accion = accion;
    this.arraydecontratos = arraydecontratos;
    callback();
  }
  
  funcionEditarTarifa(proveedor,proveedorID,accion,valoresdeentrada,callback){
    this.proveedor = proveedor;
    this.proveedorID = proveedorID;
    this.accion = accion;
    this.valoresparaeditartarifa = valoresdeentrada
    callback();
  }

  funcioneditarSummary(proveedor,proveedorID,accion,valoresdeentrada,callback){
    this.proveedor = proveedor;
    this.proveedorID = proveedorID;
    this.accion = accion;
    this.valoresparaeditartarifa = valoresdeentrada
    callback();
  }




}
